import React, { useEffect, useState } from "react";
import {
  line,
  gallery_swimpool,
  gallery_room,
  gallery_room2,
  gallery_room3,
  gallery_eagle_video,
} from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Gallery = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [displayContent, setDisplayContent] = useState<string>("video");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
      const gallyerGSAP = gsap.from(".gsapImgLeft", {
        opacity: 0,
        duration: 1,
        x: -500,
        scrollTrigger: {
          trigger: ".gsapImgLeft",
          scroller: "body",
          markers: false,
          start: "top 100%",
        },
      });
      ScrollTrigger.matchMedia({
        "(max-width: 800px)": function () {
          gallyerGSAP.vars.x = 0;
        },
      });
      const gallyerGSAP2 = gsap.from(".gsapVideoRight", {
        opacity: 0,
        duration: 1,
        x: 500,
        scrollTrigger: {
          trigger: ".gsapVideoRight",
          scroller: "body",
          markers: false,
          start: "top 100%",
        },
      });
      ScrollTrigger.matchMedia({
        "(max-width: 800px)": function () {
          gallyerGSAP2.vars.x = 0;
        },
      });
    }
  });

  const handleImageClick = (imageSrc: string) => {
    setDisplayContent(imageSrc);
    setTimeout(() => {
      setDisplayContent("video"); 
    }, 15000);
  };

  const webStyle = {
    container: {
      height: "auto",
      width: "100%",
      marginTop: "50px",
    },
  };

  return (
    <>
      <section style={webStyle.container}>
        <div
          className="h1_div "
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img className="img-size" src={line} alt="" />
          <h1
            style={{
              textAlign: "center",
              fontSize: "40px",
              padding: "26px 0px",
              margin: "0px 20px",
            }}
            className="titlesFontFamily"
          >
            Gallery
          </h1>
          <img className="img-size" src={line} alt="" />
        </div>
        <div
          className="gallery-main"
          style={{
            height: "auto",
            display: "flex",
            margin: "20px 120px",
            justifyContent: "center",
          }}
        >
          <div className="left gsapImgLeft" style={{ display: "flex", width: "100%" }}>
            <div style={{ width: "100%" }}>
              <img
                className="gallery-image GallerySelectedImage"
                src={gallery_room}
                onClick={() => handleImageClick(gallery_room)}
                style={{
                  height: "200px",
                  width: "300px",
                  borderRadius: "8px",
                  border: "1px solid black",
                  cursor: "pointer",
                }}
                alt=""
              />
              <img
                className="gallery-image GallerySelectedImage"
                src={gallery_room2}
                onClick={() => handleImageClick(gallery_room2)}
                style={{
                  height: "200px",
                  width: "300px",
                  marginTop: "5px",
                  borderRadius: "8px",
                  border: "1px solid black",
                  cursor: "pointer",
                }}
                alt=""
              />
            </div>
            <div
              className="imgdiv"
              style={{ marginLeft: "10px", width: "100%" }}
            >
              <img
                className="gallery-image GallerySelectedImage"
                src={gallery_swimpool}
                onClick={() => handleImageClick(gallery_swimpool)}
                style={{
                  height: "200px",
                  width: "300px",
                  borderRadius: "8px",
                  border: "1px solid black",
                  cursor: "pointer",
                }}
                alt=""
              />
              <img
                className="gallery-image GallerySelectedImage"
                src={gallery_room3}
                onClick={() => handleImageClick(gallery_room3)}
                style={{
                  height: "200px",
                  width: "300px",
                  marginTop: "5px",
                  borderRadius: "8px",
                  border: "1px solid black",
                  cursor: "pointer",
                }}
                alt=""
              />
            </div>
          </div>
          <div className="right gsapVideoRight">
            {displayContent === "video" ? (
              <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: "730px",
                  marginLeft: "10px",
                  borderRadius: "8px",
                  border: "1px solid black",
                }}
                className="videoContainer"
              >
                <source
                  src={gallery_eagle_video}
                  type="video/mp4"
                  style={{ width: "750px", height: "700px" }}
                />
              </video>
            ) : (
              <img
              className="videoContainer GallerySelectedImage "
                src={displayContent}
                style={{
                  width: "730px",
                  marginLeft: "10px",
                  borderRadius: "8px",
                  border: "1px solid black",
                }}
                alt="Gallery Display"
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Gallery;
